import React from 'react'

import type { RootQuery } from '@/client/query'

export const QueryContext = React.createContext<RootQuery>(null as never)

export function useQuery(): RootQuery {
  return React.useContext(QueryContext)
}
